/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'confluence-analytics-byline.abbreviated-user-views.message':
    '{count, plural, =0 {Ansichten} one {{1}} other {{count}}}',
  'confluence-analytics-byline.page-viewers.message': 'Betrachter',
  'confluence-analytics-byline.user-views.message':
    '{count, plural, =0 {Analysen} one {Angesehen von 1 Person} other {Angesehen von {count} Personen}}',
};
